import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';
import { Page, PageContent, PageHeader } from '../components/common';
import { IconAdd, IconRemove } from '../components/icons';
// import { FormCheckConditional } from '../components/forms';

import authActions from '../auth/authActions';

interface Section {
	sectionHeaderExpanded: boolean;
}
interface Props {
	currentUser: UserDetails;
	actions: any;
	history: any;
}
interface State {
	section0: Section;
	section1: Section;
	section2: Section;
	section3: Section;
	section4: Section;
	section5: Section;
	section6: Section;
}
class FAQPage extends React.Component<Props, State> {
	state = {
		section0: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false,
			q3Expanded: false
		},
		section1: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false,
			q3Expanded: false,
			q4Expanded: false,
			q5Expanded: false,
			q6Expanded: false,
			q7Expanded: false
		},
		section2: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false,
			q3Expanded: false,
			q4Expanded: false,
			q5Expanded: false,
			q6Expanded: false,
			q7Expanded: false,
			q8Expanded: false,
			q9Expanded: false,
			q10Expanded: false
		},
		section3: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false,
			q3Expanded: false,
			q4Expanded: false,
			q5Expanded: false
		},
		section4: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false
		},
		section5: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false,
			q3Expanded: false,
			q4Expanded: false,
			q5Expanded: false,
			q6Expanded: false,
		},
		section6: {
			sectionHeaderExpanded: true,
			q1Expanded: false,
			q2Expanded: false,
			q3Expanded: false,
			q4Expanded: false
		}
	};

	componentDidMount() {
		if (this.props.currentUser.isAuthenticated) {
			if ( this.props.currentUser.role !== undefined) {
				if ( this.props.currentUser.role[0] !== 'Customer' ) {
					return this.props.history.push('/admin');
				} 
				else if (!this.props.currentUser.hasBeenDirected) {
					this.props.actions.doneDirect(this.props.currentUser);
					return this.props.history.push('/user');			
				} 
			} 
		}
	}

	onRedirectClick = (e: any) => {
		e.preventDefault();
		if (this.props.currentUser.isAuthenticated) {
			if ( this.props.currentUser.role !== undefined) {
				if ( this.props.currentUser.role[0] !== 'Customer' ) {
					return this.props.history.push('/admin');
				} 
				else {
					return this.props.history.push('/user');			
				} 
			} 
		} else {
			this.props.actions.login();
		}
	}

	onSectionToggle = (section: any, header: any) => {
		this.setState({
			[section]: { ...this.state[section], [header]: !this.state[section][header] }
		});
	}

	render() {
		return (
			<Page>
				<Helmet>
					<meta charSet="utf-8"/>
					<meta
						name="description"
						content={`Mosaic life is here to make life insurance less overwhelming and more understandable. ` +
						`Discover the most frequently asked questions we get about life insurance.`}
					/>
					<title>Frequently Asked Questions | Mosaic Life</title>
				</Helmet>
				<PageContent>
					<PageHeader title="Frequently Asked Questions" />
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section0.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section0', 'sectionHeaderExpanded')}
							>
								{this.state.section0.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Questions about Mosaic Life</span>
							</button>
						</h2>
						{this.state.section0.sectionHeaderExpanded &&
						<div className="form-check-conditional faq-question-answer">
							<div className="form-check-conditonal-content-wrapper">
							<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section0.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section0', 'q1Expanded')}
								>
									{this.state.section0.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Where is Mosaic Life located?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section0.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											We are 100% Canadian-owned and operated. 
											<br /> 
											We call Edmonton home, but we provide insurance across the country.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section0.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section0', 'q2Expanded')}
								>
									{this.state.section0.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How do I contact Mosaic Life?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section0.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Call us at <a href="tel:1-855-643-6945">1-855-643-6945</a>, chat with us online, or email us at{' '}
											<a href="mailto:info@insuredbymosaic.ca">info@insuredbymosaic.ca</a>. 
											We look forward to hearing from you!
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section0.q3Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section0', 'q3Expanded')}
								>
									{this.state.section0.q3Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Who is backing Mosaic Life?</span>
								</button>
							</h3>							
							<div className={`form-check-conditional faq-question-answer ${this.state.section0.q3Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Mosaic Life policies are backed by First Canadian Insurance Corporation, a Canadian life insurance 
											company that has been in business for over 30 years. First Canadian has provided protection to over
											1 million Canadian families.  First Canadian is rated ‘A (Excellent) with stable outlook’ by
											A.M. Best, the major ratings agency for insurance companies.
										</p>
									</div>
								</div>
							</div>
							</div>
							</div>
							</div>
							}
					</div>
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section1.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section1', 'sectionHeaderExpanded')}
							>
								{this.state.section1.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Life Insurance</span>
							</button>
						</h2>
						{this.state.section1.sectionHeaderExpanded &&
							<div className="form-check-conditional faq-question-answer">
								<div className="form-check-conditonal-content-wrapper">
								<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q1Expanded')}
								>
									{this.state.section1.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What is life insurance?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Life is full of unexpected events, some positive, and unfortunately, some negative. Life insurance
											provides financial protection for your loved ones in the event that you pass away. If you die while
											your policy is in place, your loved ones will receive a financial payout, known in the industry as the
											‘death benefit’ (we know, it’s kind of morbid), and in exchange for that protection, you pay
											a monthly payment, known as the 'premium'.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q2Expanded')}
								>
									{this.state.section1.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Do I need life insurance?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											People commonly buy life insurance after important life events, such as getting married, having a
											child, buying a home, or starting a new job. Bottom line is, if you have people in your life who you
											are financially responsible for, you should consider life insurance so that they have support in case
											you pass away.
										</p>
										<p>
											Unfortunately, most people overlook life insurance until they actually need it, at which point the
											cost of insurance increases significantly (assuming you can find coverage at all). The best time to
											buy insurance is when you are young and healthy. Plan for future you.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q3Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q3Expanded')}
								>
									{this.state.section1.q3Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Can I get life insurance through my employer?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q3Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>Absolutely, and you should consider doing so if it’s offered as part of your employee benefits.</p>
										<p>
											However, many employer-based plans limit your coverage to a certain percentage of your income,
											and quite often, that amount is not enough to cover your financial obligations in the event you
											die. So, many people top up their employer-based plans with additional term life insurance. 
										</p>
										<p>
											The additional benefits of a term policy over employer-based coverage are that with a term policy,
											coverage stays in place in the event you switch jobs, and the premiums do not increase as you 
											get older.
										</p>
										<p>
											Use our <a href="/quote/B/about-you">calculator</a> to figure out how much insurance you need in 
											addition to your employer-provided coverage.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q4Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q4Expanded')}
								>
									{this.state.section1.q4Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How much coverage do I need?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q4Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											While there are general rules of thumb (e.g., budgeting 1% of gross income for insurance premiums), 
											there’s no single right answer, because the amount of coverage you need will depend on your current 
											and expected future life situation. 
										</p>
										<p>
											There are a number of factors to consider, such as family size, income, lifestyle, savings,
											debt, and budget. On top of that, the reality is that your insurance needs will likely change 
											over time. For example, you might want more coverage if you have an addition to the family, 
											or you might want less coverage after your mortgage is paid off.			
										</p>
										<p>
											Our <a href="/quote/B/about-you">calculator</a> can help you determine the appropriate amount of 
											coverage based on your personal situation.
										</p>
										<p>
											Remember that life insurance doesn't have to be an all or none decision. Even if you can’t afford 
											the amount of coverage you would like, having at least some coverage will help protect your 
											loved ones.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q5Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q5Expanded')}
								>
									{this.state.section1.q5Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How long of a term do I need?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q5Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Mosaic Life offers terms ranging from 10 years to “T65” (industry lingo for coverage until
											you turn 65 years old).
										</p>
										<p>
											The appropriate term for you will vary based on your personal situation.
											Things to consider include how long you expect to be financially responsible for others, your current
											and expected savings and debts, and your budget. Also keep in mind that financial
											commitments can vary over time. For example, you might need additional insurance when you have a
											new child, and less when a child graduates from college and starts working.
										</p>
										<p>
											Our <a href="/quote/B/about-you">calculator</a> can help you figure out the right term based on your 
											personal situation.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q6Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q6Expanded')}
								>
									{this.state.section1.q6Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">If I die, who receives the life insurance payout?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q6Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Your payout is paid to the person(s) you name as your beneficiary on the beneficiary designation form. 
											For most people, the payout is made to close family members (e.g., spouse, children, or parents). 
											You are allowed to name more than one beneficiary if you’d like. 
											In that case, you need to allocate each beneficiary a percentage or dollar amount of the payout.
										</p>
										<p>
											If you do not complete a beneficiary designation form, the payout will be made to your estate.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section1.q7Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section1', 'q7Expanded')}
								>
									{this.state.section1.q7Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What’s an underwriter?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section1.q7Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											The underwriter is the insurance company that is backing the policy—i.e., the one who is on the hook
											for paying out the death benefit. It is important that the underwriter be financially stable so that
											you can be confident that it will be around when you need it. A third party rating agency, A.M. Best,
											provides ratings on the financial health of various insurance companies.
										</p>
										<p>
											Mosaic Life’s underwriter is First Canadian Insurance Corporation, headquartered in Edmonton, 
											Alberta. First Canadian has been in business for over 30 years and has an A.M. Best rating of 
											‘A (Excellent) with stable outlook’.
										</p>
									</div>
								</div>
							</div>
							</div>
							</div>
							</div>
							}
					</div>
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section2.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section2', 'sectionHeaderExpanded')}
							>
								{this.state.section2.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Obtaining Coverage</span>
							</button>
						</h2>
						{this.state.section2.sectionHeaderExpanded &&
							<div className="form-check-conditional faq-question-answer">
								<div className="form-check-conditonal-content-wrapper">
								<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q1Expanded')}
								>
									{this.state.section2.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How do I buy a Mosaic Life policy?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											We offer our policies directly to consumers through our online application. Unlike most insurance
											companies, we do not rely on brokers or agents, which means we don’t pay a sales commissions every
											time a policy is sold. We pass those savings on to you.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q10Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q10Expanded')}
								>
									{this.state.section2.q10Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How does the free two month offer work?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q10Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											When you purchase a new Mosaic Life policy, the first two months of your coverage will be absolutely free.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q2Expanded')}
								>
									{this.state.section2.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Who is eligible to apply for a Mosaic Life policy?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>Mosaic Life is available to Canadian citizens and residents between the ages of 18 and 55.</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q3Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q3Expanded')}
								>
									{this.state.section2.q3Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How long does it take to get coverage?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q3Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											We believe that protecting your loved ones should be simple. Healthy individuals are able to obtain
											coverage with Mosaic Life in as little as 10 minutes.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q4Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q4Expanded')}
								>
									{this.state.section2.q4Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">
										Will I need to complete a medical exam or provide bodily fluids as part of my application?
									</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q4Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											For most people, no. Unlike other life insurers, we do not typically require you to provide blood and
											urine samples or to complete a medical exam. Instead, we base our decision on our online questionnaire,
											which for most people, takes under 10 minutes to complete.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q5Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q5Expanded')}
								>
									{this.state.section2.q5Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What’s the maximum coverage I can take?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q5Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											You can have up to $1 million Canadian in aggregate coverage from Mosaic Life. This limit applies 
											across all of your Mosaic Life policies.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q6Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q6Expanded')}
								>
									{this.state.section2.q6Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What am I covered for? What is not covered?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q6Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Your policy covers you if you die during the term of the policy, unless your death is related to one
											of the following:
											<ul>
												<li>suicide within the first two years of the policy</li>
												<li>you committing or attempting to commit a criminal act (including driving under the influence)</li>
												<li>an act of war (whether declared or not)</li>
											</ul>
										</p>
										<p>
											Based on your answers to our questionnaire, your policy may also exclude certain risky lifestyle 
											activities. If this is the case your policy will explicitly call out these activities so that there 
											is no ambiguity about what's not covered.
										</p>
										<p>
											You will also not be covered if your application is deemed fraudulent or contains a material
											misrepresentation. This includes not accurately disclosing your smoking habits on the application.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q7Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q7Expanded')}
								>
									{this.state.section2.q7Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">
										Can I switch to Mosaic Life if I already have a life policy?
									</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q7Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											No, Mosaic Life policies are not intended to replace other existing coverage. But you are allowed 
											to have a Mosaic Life policy alongside of another insurer's policy. 
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q8Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q8Expanded')}
								>
									{this.state.section2.q8Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Will I ever need more than one policy?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q8Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Potentially, depending on how your personal situation changes over time. With Mosaic Life, it’s easy
											to apply for additional policies as you need more coverage (and cancel them as you need less
											coverage). Each individual can get coverage up to an aggregate limit of $1 million Canadian.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section2.q9Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section2', 'q9Expanded')}
								>
									{this.state.section2.q9Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Is the death benefit taxed?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section2.q9Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											In the majority of cases, if you've completed your beneficiary designation form, the benefit is 
											not taxed. But our lawyers tell us we’re not tax experts so you should seek advice if you’re unsure.
										</p>
									</div>
								</div>
							</div>
						</div>
						</div>
						</div>
						}
					</div>
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section3.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section3', 'sectionHeaderExpanded')}
							>
								{this.state.section3.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Premiums</span>
							</button>
						</h2>
						{this.state.section3.sectionHeaderExpanded &&
							<div className="form-check-conditional faq-question-answer">
								<div className="form-check-conditonal-content-wrapper">
								<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section3.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section3', 'q1Expanded')}
								>
									{this.state.section3.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What’s a premium?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section3.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Your premium is the amount you pay each month to maintain your insurance coverage. Premiums vary by
											individual based on factors such as the desired coverage amount, the length of the policy, and the
											applicant’s age, gender, tobacco usage, lifestyle, and medical history.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section3.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section3', 'q2Expanded')}
								>
									{this.state.section3.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Will my premiums change over time?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section3.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>Your monthly premiums will not change during the term of your policy.</p>
										<p>
											That said, if you apply for an additional Mosaic Life policy, your premiums for that new policy will
											possibly be different from the premiums for your existing policy, as you will be older and your 
											lifestyle and medical situation may have changed.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section3.q3Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section3', 'q3Expanded')}
								>
									{this.state.section3.q3Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Will my premiums change if I’m diagnosed with an illness?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section3.q3Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>No. After you purchase your policy, your premiums are guaranteed for the term of that policy.</p>
										<p>
											However, if you have an illness (or symptoms of an illness) before you apply for insurance and don’t
											properly disclose it on your application, your coverage may be voided for misrepresentation or 
											fraud.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section3.q4Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section3', 'q4Expanded')}
								>
									{this.state.section3.q4Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How do I pay my premium?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section3.q4Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											You can pay your monthly premium by credit card.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section3.q5Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section3', 'q5Expanded')}
								>
									{this.state.section3.q5Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What happens if I miss my premium payment?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section3.q5Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											If you do not make a premium payment in full by the due date, you will have a 31-day grace period to make the
											payment. After that grace period, your coverage will automatically terminate.
										</p>
									</div>
								</div>
							</div>
						</div>
						</div>
						</div>
						}
					</div>
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section4.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section4', 'sectionHeaderExpanded')}
							>
								{this.state.section4.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Data & Security</span>
							</button>
						</h2>
						{this.state.section4.sectionHeaderExpanded &&
							<div className="form-check-conditional faq-question-answer">
								<div className="form-check-conditonal-content-wrapper">
								<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section4.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section4', 'q1Expanded')}
								>
									{this.state.section4.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What happens to the information I give you?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section4.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											We use the information you provide on your application to make a decision on your application and
											for our own risk-monitoring analytics. 
										</p>
										<p>
											We will not sell your information to third-party advertisers.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section4.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section4', 'q2Expanded')}
								>
									{this.state.section4.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How secure is my information?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section4.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											We have taken a technology-first approach to insurance. This includes focusing heavily on data 
											security. We do not store login credentials or credit card information on our servers, and all data 
											is fully encrypted.
										</p>
									</div>
								</div>
							</div>
						</div>
						</div>
						</div>
						}
					</div>
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section5.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section5', 'sectionHeaderExpanded')}
							>
								{this.state.section5.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Managing My Policy</span>
							</button>
						</h2>
						{this.state.section5.sectionHeaderExpanded &&
							<div className="form-check-conditional faq-question-answer">
								<div className="form-check-conditonal-content-wrapper">
								<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section5.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section5', 'q1Expanded')}
								>
									{this.state.section5.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Can I modify my policy?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section5.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											You are able to make limited changes to your policy, including changes to your beneficiaries, 
											contact information, and payment details.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section5.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section5', 'q2Expanded')}
								>
									{this.state.section5.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How do I change a beneficiary?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section5.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											To change a beneficiary, you will need to update your beneficiary designation form. You can find
											instructions on how to do this when you sign into your 
											<a onClick={this.onRedirectClick} href="#"> online account</a>.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section5.q3Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section5', 'q3Expanded')}
								>
									{this.state.section5.q3Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How do I change my contact information and payment details?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section5.q3Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											You can manage your contact information and payment details by signing in to 
											your <a onClick={this.onRedirectClick} href="#"> online account</a>.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section5.q4Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section5', 'q4Expanded')}
								>
									{this.state.section5.q4Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Can I cancel my policy?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section5.q4Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>Yes, you can cancel your policy at any time.</p>
										<p>
											If you cancel within 30 days of your policy's start date, you will receive a full refund of your premium.
											If you cancel after that, you will receive a pro-rated refund of the premium you paid in the month you
											cancel.
										</p>
										<p>
											If you have multiple Mosaic Life policies, you can choose to cancel certain policies while keeping
											others in place. Stacking and unstacking policies is an effective way of increasing or decreasing
											coverage as your life situation changes over time.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section5.q5Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section5', 'q5Expanded')}
								>
									{this.state.section5.q5Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Is there a fee for modifying or cancelling a policy?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section5.q5Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>Nope.</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section5.q6Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section5', 'q6Expanded')}
								>
									{this.state.section5.q6Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">Can I review a sample policy prior to signing up?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section5.q6Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Here is a <a href="/Term Life Policy Sample.pdf" target="_blank">sample policy</a>.
										</p>
									</div>
								</div>
							</div>
						</div>
						</div>
						</div>
						}
					</div>
					<div className="faq-section">
						<h2 className="faq-question">
							<button
								className={`faq-question-clickable${this.state.section6.sectionHeaderExpanded ? ' active' : ''}`}
								onClick={() => this.onSectionToggle('section6', 'sectionHeaderExpanded')}
							>
								{this.state.section6.sectionHeaderExpanded ? <IconRemove /> : <IconAdd />}
								<span className="faq-question-title">Claims</span>
							</button>
						</h2>
						{this.state.section6.sectionHeaderExpanded &&
							<div className="form-check-conditional faq-question-answer">
								<div className="form-check-conditonal-content-wrapper">
								<div className="form-check-conditional-content">
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section6.q1Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section6', 'q1Expanded')}
								>
									{this.state.section6.q1Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">
										Where will my loved ones find the details they need to submit a claim?
									</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section6.q1Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											Good question. Sharing policy details with loved ones is often an overlooked step after obtaining
											insurance coverage. It is important that you have a plan ahead of time so that your loved ones know
											about your policy if you pass away.
										</p>
										<p>
											While each family situation is different, to the extent you want to notify your beneficiaries of this
											policy upfront, you can share the policy by email through our online portal. If you select this
											option, your beneficiaries will be notified any time changes to your beneficiary designation form are
											made.
										</p>
										<p>
											Also, in the event we see a missed premium payment on your policy, we will try to contact you to fix
											the issue. You have the option of providing a backup contact for us to reach out to if we are unable
											to get ahold of you regarding the payment in the event that your payments ceased due to your passing.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section6.q2Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section6', 'q2Expanded')}
								>
									{this.state.section6.q2Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">
										I’m a beneficiary, next-of-kin, or estate executor. How do I file a claim?
									</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section6.q2Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>First off, we’re sorry for your loss.</p>								
										<p>
											You can initiate your claim either <a href="/claims">online</a> or
											by calling us at <a href="tel:780-417-5480">780-417-5480</a>.
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section6.q3Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section6', 'q3Expanded')}
								>
									{this.state.section6.q3Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">What information is needed to submit a claim?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section6.q3Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											An authorized person (e.g., a beneficiary, next of kin, or estate trustee) will need to submit a claim. 
											In order to validate the claim, we will need to verify certain information, including the following:
											<ul>
												<li>the date and cause of death</li>
												<li>the insured’s age, sex at birth, and smoking class at the time of application</li>
												<li>that the person making the claim has the authority to do so</li>
											</ul>
										</p>
										<p>
											There are a few documents that may be needed to process a claim, such as the following:								
											<ul>
												<li>an authorization for release of personal information</li>
												<li>a claimant's statement</li>
												<li>a physician statement</li>
												<li>death certificate and either birth certificate or driver's license</li>
												<li>if the cause of death is accidental, a police report or workplace accident report</li>
											</ul>
										</p>
										<p>
											It may sound like a lot, but our claims team will walk you through the process step-by-step.								
										</p>
									</div>
								</div>
							</div>
							<h3 className="faq-question">
								<button
									className={`faq-question-clickable${this.state.section6.q4Expanded ? ' active' : ''}`}
									onClick={() => this.onSectionToggle('section6', 'q4Expanded')}
								>
									{this.state.section6.q4Expanded ? <IconRemove /> : <IconAdd />}
									<span className="faq-question-title">How long does it take to receive a life insurance payout?</span>
								</button>
							</h3>
							<div className={`form-check-conditional faq-question-answer ${this.state.section6.q4Expanded ? '' : 'd-none'}`}>
								<div className="form-check-conditonal-content-wrapper">
									<div className="form-check-conditional-content">
										<p>
											We try to process claims as quickly as possible, though there are some necessary administrative steps 
											we have to take when we receive a claim to minimize the risk of fraud. Our goal is to process your  
											claim in under 5 business days from when we receive the required documentation for the claim.
										</p>
									</div>
								</div>
							</div>
						</div>
						</div>
						</div>
						}
					</div>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser
	};
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(FAQPage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/FAQPage.tsx